import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { LOCATION_NAV_BAR_HEIGHT } from '../constants';

/*
 ** These are currently sharing the "provider_profile_*" styles.
 ** We need to merge these into a more generic key like "profile_" which we plan to handle in HSAP-3518
 */
export const AppointmentAsideContainer = styled.aside`
  padding: ${fromTheme('spacing_medium')};
  border-radius: ${(props) =>
    fromTheme('provider_profile_border_radius')(props)};
  border: ${(props) =>
    `${fromTheme('provider_profile_border_style')(props)} ${fromTheme(
      'provider_profile_color_border'
    )(props)} ${fromTheme('provider_profile_border_width')(props)}`};
  box-shadow: ${(props) => fromTheme('provider_profile_box_shadow')(props)};
  -webkit-box-shadow: ${(props) =>
    fromTheme('provider_profile_box_shadow')(props)};
  -moz-box-shadow: ${(props) =>
    fromTheme('provider_profile_box_shadow')(props)};
`;

export const AppointmentAsideStickyBox = styled('div')`
  @media screen and (min-width: 993px) {
    position: sticky;
    top: calc(
      var(${LOCATION_NAV_BAR_HEIGHT}, 74px) + ${fromTheme('spacing_medium')}
    );
    height: 100vh;
    overflow-y: auto;
  }
`;

export const ScheduleAppointmentTitle = styled('h2')`
  margin: 0 0 ${fromTheme('spacing_medium')} 0;
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  color: ${fromTheme('color_text')};
`;
